import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import { Button } from './Button';
import { CALENDAR_SCOPE_ERROR_EVENT } from '@/utils/calendarScopeError';

/**
 * カレンダー連携スコープ不足時の案内モーダル
 * 403エラー発生時に表示し、再ログインを促す
 */
const CalendarScopeErrorModal = () => {
    const { t } = useTranslation('common');
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleScopeError = () => setIsOpen(true);
        window.addEventListener(CALENDAR_SCOPE_ERROR_EVENT, handleScopeError);
        return () => window.removeEventListener(CALENDAR_SCOPE_ERROR_EVENT, handleScopeError);
    }, []);

    const handleRedirect = useCallback(() => {
        setIsOpen(false);
        window.location.replace('/login');
    }, []);

    if (!isOpen) return null;

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleRedirect}
            contentClassName="w-full max-w-md p-10 text-center space-y-6"
            disableCloseOnEsc
            disableCloseOnOverlay
        >
            <h2 className="text-2xl font-bold text-gray-900">{t('calendarScopeError.title')}</h2>
            <p className="text-base leading-relaxed text-gray-700 whitespace-pre-line">
                {t('calendarScopeError.message')}
            </p>
            <div className="flex justify-center">
                <Button variant="primary" className="w-full px-8" onClick={handleRedirect}>
                    {t('calendarScopeError.cta')}
                </Button>
            </div>
        </Modal>
    );
};

export default CalendarScopeErrorModal;
